import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

import { ContactUs } from "src/library/components/exports";
import { RoutingIDEnum } from "src/library/types/types";
import { zIndexes } from "src/library/styles/theme";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        pt: 3,
        pb: 6,
        px: 2,
        mt: "auto",
        bgcolor: "primary.light",
        position: "relative",
        zIndex: zIndexes.Above,
      }}
    >
      <Container maxWidth="sm" id={RoutingIDEnum.Contact}>
        <ContactUs />
      </Container>
    </Box>
  );
}
